import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import Styles from './style.css';
import UserCampaignsRunning from "../../components/user-campaigns-running/component";
import UserCampaignsRunningEdit from "../../components/user-campaigns-running-edit/component";
import UserCampaignsDrafts from "../../components/user-campaigns-drafts/component";
import UserCampaignsDraftsEdit from "../../components/user-campaigns-drafts-edit/component";
import UserCampaignsHistory from "../../components/user-campaigns-history/component";
import UserCampaignsHistoryEdit from "../../components/user-campaigns-history-edit/component";
import UserBillingInvoices from "../../components/user-billing-invoices/component";
import UserProfile from "../../components/user-profile/component";
import UserInvite from "../../components/user-invite/component";
import UserSettings from "../../components/user-settings/component";
import UserFeeds from "../../components/user-feeds/component";
import UserLeads from "../../components/user-leads/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import UserInsights from "../../components/user-insights/component";
import {tokenRegister} from "../../services/tokenRegister";
import BoosterHeaderDashboard from "../../components/booster-header-dashboard/component";
import UserCampaignsArchived from "../../components/user-campaigns-archived/component";

import UserSettlements from "../../components/user-settlements/component";
import UserAgents from "../../components/user-agents/component";
import {agentRegister} from "../../services/agentRegister";

class BoosterUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            selected: "",
            dropdown: {
                campaigns: false,
                billing: false
            },
            user: {},
            campaigns_active: 0,
            campaigns_drafts: 0,
            campaigns_history: 0,
            campaigns_archived: 0
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._setView();
        this._updateUser();
        this._resetSignUp();
        this._updateCampaigns();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user');
            ReactGA4.send({ hitType: "pageview", page: "/user" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this._setView();
            window.scrollTo(0, 0);
        }
    }

    _updateUser() {
        let user = userRegister.get();
        if (user) {
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse,
                reseller_type: user.reseller_type
            });
            if (user.socialData) {
                this.setState({
                    settlements: user.socialData.settlements ? user.socialData.settlements : false,
                    branding: user.socialData.branding ? user.socialData.branding : false,
                    crm: user.socialData.crm ? user.socialData.crm : false,
                    feeds: user.socialData.feeds ? user.socialData.feeds : false
                });
            }
        }
    }

    _updateCampaigns() {
        dataRegister.getCampaignsCount(salesChannelRegister.get('market')).then((response) => {

            console.log(response);

            let AWAITING_PAYMENT = response.AWAITING_PAYMENT ? response.AWAITING_PAYMENT : 0;
            let SETUP_CBM = response.SETUP_CBM ? response.SETUP_CBM : 0;
            let RUNNING = response.RUNNING ? response.RUNNING : 0;
            let AUTO_BILL = response.AUTO_BILL ? response.AUTO_BILL : 0;
            let READY = response.READY ? response.READY : 0;
            let ENDED = response.ENDED ? response.ENDED : 0;
            let ENDED_RENEW = response.ENDED_RENEW ? response.ENDED_RENEW : 0;
            let TERMINATED = response.TERMINATED ? response.TERMINATED : 0;
            let TERMINATED_ENDED = response.TERMINATED_ENDED ? response.TERMINATED_ENDED : 0;
            let TERMINATED_RENEW = response.TERMINATED_RENEW ? response.TERMINATED_RENEW : 0;
            let ARCHIVED = response.ARCHIVED ? response.ARCHIVED : 0;
            let DISAPPROVED = response.DISAPPROVED ? response.DISAPPROVED : 0;
            let ARCHIVED_DISAPPROVED = response.ARCHIVED_DISAPPROVED ? response.ARCHIVED_DISAPPROVED : 0;
            let RELEASE = response.RELEASE ? response.RELEASE : 0;
            let DRAFT = response.DRAFT ? response.DRAFT : 0;
            let ARCHIVED_DRAFT = response.ARCHIVED_DRAFT ? response.ARCHIVED_DRAFT : 0;

            this.setState({
                campaigns_active: AWAITING_PAYMENT + RUNNING + AUTO_BILL + READY + SETUP_CBM + DISAPPROVED + RELEASE,
                campaigns_drafts:  DRAFT,
                campaigns_history: ENDED + ENDED_RENEW + TERMINATED_ENDED + TERMINATED + TERMINATED_RENEW,
                campaigns_archived: ARCHIVED + ARCHIVED_DISAPPROVED + ARCHIVED_DRAFT,
                isLoading: false
            });

        }, (error) => {
            if (error.status === 401) {
                tokenRegister.remove();
                userRegister.remove();
                agentRegister.remove();
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/login");
            } else {
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _setView() {
        try {
            this.setState({selected: this.props.location.pathname}, () => {
                if (this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/payment" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/receipts") {
                    this.state.dropdown.billing = true;
                    this.setState({dropdown: this.state.dropdown});
                } else if (this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/drafts" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/history" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/archived") {
                    this.state.dropdown.campaigns = true;
                    this.setState({dropdown: this.state.dropdown});
                }else if(this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/admin" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/agents"){
                    this.state.dropdown.profile = true;
                    this.setState({dropdown: this.state.dropdown});
                }
            });
        } catch (error) {
        }
    }

    _resetSignUp() {
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
    }

    _goTo(value) {
        this.setState({selected: value}, () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + value)
        });
    }

    _renderText(item) {
        return langRegister.get("user", item);
    }

    render() {
        return (
            <div>
                {
                    !this.state.isLoading &&
                    <div>
                        <span className={Styles.mobileMenu}>
                            <BoosterHeaderDashboard props={this.props}/>
                        </span>
                        <div className={Styles.container}>
                            <div className={Styles.menu}>
                                <div className={Styles.menuHeader}>
                                    <img onClick={() => {
                                        if (this.props.location.pathname.indexOf("running") === -1) {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/running")
                                        } else {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang())
                                        }
                                    }} className={Styles.menuHeaderLogo}
                                         src={salesChannelRegister.get('logo_dashboard')}/>
                                </div>
                                <div onClick={() => {
                                    this.state.dropdown.campaigns = !this.state.dropdown.campaigns;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/gloce-icon.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_1")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.campaigns,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpenCampaigns]: this.state.dropdown.campaigns,
                                        })
                                }>


                                    <div onClick={() => this._goTo("/user/campaigns/running")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("running") !== -1,
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("running") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("running") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("running") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/flag-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_3")}
                                        </div>
                                        {
                                            this.state.campaigns_active > 0 &&
                                            <div className={Styles.menuItemIndicator}>
                                                {this.state.campaigns_active > 999 ? this._renderText("item_19") : this.state.campaigns_active}
                                            </div>
                                        }
                                    </div>

                                    {
                                        this.state.branding && this.state.crm && this.state.feeds &&
                                    <div onClick={() => this._goTo("/user/campaigns/drafts")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("drafts") !== -1,
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("drafts") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("drafts") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("drafts") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/pen-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_17")}
                                        </div>
                                        {
                                            this.state.campaigns_drafts > 0 &&
                                            <div className={Styles.menuItemIndicator}>
                                                {this.state.campaigns_drafts > 999 ? this._renderText("item_19") : this.state.campaigns_drafts}
                                            </div>
                                        }
                                    </div>
                                    }

                                    <div onClick={() => this._goTo("/user/campaigns/history")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("history") !== -1,
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("history") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("history") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("history") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/arrow_down_white.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_4")}
                                        </div>
                                        {
                                            this.state.campaigns_history > 0 &&
                                            <div
                                                style={salesChannelRegister.get('name') === "yieldlock" ? {background: '#E65032'} : {}}
                                                className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorOrange)}>
                                                {this.state.campaigns_history > 999 ? this._renderText("item_19") : this.state.campaigns_history}
                                            </div>
                                        }
                                    </div>

                                    <div onClick={() => this._goTo("/user/campaigns/archived")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("archived") !== -1,
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("archived") !== -1,
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected.indexOf("archived") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected.indexOf("archived") !== -1 &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/cloud_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                        {
                                            this.state.campaigns_archived > 0 &&
                                            <div className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorGrey)}>
                                                {this.state.campaigns_archived > 999 ? this._renderText("item_19") : this.state.campaigns_archived}
                                            </div>
                                        }
                                    </div>

                                </div>

                                <div onClick={() => {
                                    this.state.dropdown.billing = !this.state.dropdown.billing;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/sheets_white_icon.png")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.billing,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpen]: this.state.dropdown.billing,
                                        })
                                }>
                                    <div onClick={() => this._goTo("/user/billing/receipts")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/receipts",
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/receipts",
                                                     [Styles.menuItemPassive]: this.state.dropdown.billing,
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/receipts" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/billing/receipts" &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/price_white_icon.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_6")}
                                        </div>
                                    </div>

                                </div>
                                {
                                    this.state.inhouse &&
                                    <div onClick={() => {
                                        this.state.dropdown.profile = !this.state.dropdown.profile;
                                        this.setState({dropdown: this.state.dropdown})
                                    }} className={Styles.menuItem}>
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/user-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_7")}
                                        </div>
                                        <img
                                            className={
                                                cx(Styles.menuItemArrow,
                                                    {
                                                        [Styles.menuItemArrowActive]: this.state.dropdown.profile,
                                                    })
                                            } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                    </div>
                                }
                                {
                                    this.state.inhouse &&
                                    <div className={
                                        cx(Styles.menuDropdown,
                                            {
                                                [Styles.menuDropdownOpen]: this.state.dropdown.profile,
                                            })
                                    }>
                                        <div onClick={() => this._goTo("/user/profile/admin")}
                                             className={
                                                 cx(Styles.menuItem,
                                                     {
                                                         [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/admin",
                                                         [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/admin",
                                                         [Styles.menuItemPassive]: this.state.dropdown.profile,
                                                     })
                                             }>
                                            {
                                                salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/admin" &&
                                                <div className={Styles.menuItemSelectedBorder}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/admin" &&
                                                <div className={Styles.menuItemSelectedBorderYL}/>
                                            }
                                            <img className={Styles.menuItemIcon}
                                                 src={require("../../assets/images/gloce-icon.svg")}/>
                                            <div className={Styles.menuItemTitle}>
                                                {this._renderText("item_14")}
                                            </div>
                                        </div>
                                        <div onClick={() => this._goTo("/user/profile/agents")}
                                             className={
                                                 cx(Styles.menuItem,
                                                     {
                                                         [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/agents",
                                                         [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/agents",
                                                         [Styles.menuItemPassive]: this.state.dropdown.profile,
                                                     })
                                             }>
                                            {
                                                salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/agents" &&
                                                <div className={Styles.menuItemSelectedBorder}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile/agents" &&
                                                <div className={Styles.menuItemSelectedBorderYL}/>
                                            }
                                            <img className={Styles.menuItemIcon}
                                                 src={require("../../assets/images/user-icon-white.svg")}/>
                                            <div className={Styles.menuItemTitle}>
                                                {this._renderText("item_15")}
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    !this.state.inhouse &&
                                    <div onClick={() => this._goTo("/user/profile")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile",
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile",
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/profile" &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/user-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_7")}
                                        </div>
                                    </div>
                                }
                                {
                                    this.state.feeds &&
                                <div onClick={() => this._goTo("/user/feeds")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/feeds",
                                                 [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/feeds",
                                             })
                                     }>
                                    {
                                        salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/feeds" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    {
                                        salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/feeds" &&
                                        <div className={Styles.menuItemSelectedBorderYL}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/gloce-icon.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_16")}
                                    </div>
                                </div>
                                }
                                {
                                    this.state.branding &&
                                    <div onClick={() => this._goTo("/user/leads")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/leads",
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/leads",
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/leads" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/leads" &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/user-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_18")}
                                        </div>
                                    </div>
                                }
                                <div onClick={() => this._goTo("/user/settings")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settings",
                                                 [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settings",
                                             })
                                     }>
                                    {
                                        salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settings" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    {
                                        salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settings" &&
                                        <div className={Styles.menuItemSelectedBorderYL}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/settings-icons-white.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_9")}
                                    </div>
                                </div>

                                {
                                    (this.state.reseller || this.state.inhouse) &&
                                    <div onClick={() => this._goTo("/user/insights")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/insights",
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/insights",
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/insights" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/insights" &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/stats_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_11")}
                                        </div>
                                    </div>
                                }

                                {
                                    (this.state.reseller || this.state.inhouse) && this.state.settlements && //this.state.reseller_type === "commission" &&
                                    <div onClick={() => this._goTo("/user/settlements")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settlements",
                                                     [Styles.menuItemActiveYL]: salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settlements",
                                                 })
                                         }>
                                        {
                                            salesChannelRegister.get('name') !== 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settlements" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === 'yieldlock' && this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/settlements" &&
                                            <div className={Styles.menuItemSelectedBorderYL}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/stack-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_13")}
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className={Styles.content}>
                                <Route exact path={this.props.match.url + "/campaigns/archived"}
                                       component={UserCampaignsArchived}/>
                                <Route exact path={this.props.match.url + "/campaigns/running"}
                                       component={UserCampaignsRunning}/>
                                <Route exact path={this.props.match.url + "/campaigns/running/:hash"}
                                       component={UserCampaignsRunningEdit}/>
                                <Route exact path={this.props.match.url + "/campaigns/drafts"}
                                       component={UserCampaignsDrafts}/>
                                <Route exact path={this.props.match.url + "/campaigns/drafts/:hash"}
                                       component={UserCampaignsDraftsEdit}/>
                                <Route exact path={this.props.match.url + "/campaigns/history"}
                                       component={UserCampaignsHistory}/>
                                <Route exact path={this.props.match.url + "/campaigns/history/:hash"}
                                       component={UserCampaignsHistoryEdit}/>
                                <Route exact path={this.props.match.url + "/billing/receipts"}
                                       component={UserBillingInvoices}/>
                                <Route exact path={this.props.match.url + "/profile"} component={UserProfile}/>
                                <Route exact path={this.props.match.url + "/profile/admin"} component={UserProfile}/>
                                <Route exact path={this.props.match.url + "/profile/agents"} component={UserAgents}/>
                                <Route exact path={this.props.match.url + "/invite"} component={UserInvite}/>
                                <Route exact path={this.props.match.url + "/settings"} component={UserSettings}/>
                                <Route exact path={this.props.match.url + "/feeds"} component={UserFeeds}/>
                                <Route exact path={this.props.match.url + "/leads"} component={UserLeads}/>
                                <Route exact path={this.props.match.url + "/insights"} component={UserInsights}/>
                                <Route exact path={this.props.match.url + "/settlements"} component={UserSettlements}/>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

export default BoosterUser;


// WEBPACK FOOTER //
// ./src/pages/booster-user/component.js